import { Box, Typography } from '@mui/material';
import useFailureDialogStyles from './styles/useFailureDialogStyles';
import FeatureIcon from '@assetron/web-common/components/logo/icon_component/feature_icon';
import { useLocalization } from '@assetron/common/hooks/useLocalization';
import { ORG_NAME } from '@assetron/common/constants/constant';

function FailureDialog() {
  const styles = useFailureDialogStyles();
  const { t } = useLocalization();

  const orgName = window.sessionStorage.getItem(ORG_NAME);

  return (
    <Box sx={styles.rootContainer}>
      <Box sx={styles.mainBox}>
        <FeatureIcon />
        <Box sx={styles.content}>
          <Typography variant="large_heading_30_semibold" sx={styles.header}>
            {t('userInvitation.invitationHeading', {
              orgName,
            })}
          </Typography>
          <Typography variant="body_14_regular" sx={styles.description}>
            {t('userInvitation.invitationDescription')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default FailureDialog;
